var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tooltip',[_c('template',{slot:"title"},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]),_c('i',{staticClass:"ml-1 cursor-pointer text-muted fas fa-info-circle"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }